import type { ComponentProps } from 'react';

import { Skeleton } from '@mint-lib/tw-components';

export const SkeletonRow = ({
  rowsCount,
  variants,
}: {
  rowsCount: number;
  variants: Partial<ComponentProps<typeof Skeleton>>[];
}) => {
  const rowIds = Array.from(
    { length: rowsCount },
    (_, index) => `skeleton-row-${index}`,
  );
  const variantsWithKeys = variants.map((skeletonProps, index) => ({
    key: `skeleton-cell-${index}`,
    skeletonProps,
  }));

  return rowIds.map((rowId) => (
    <div key={rowId} className="flex items-center justify-between">
      {variantsWithKeys.map(({ key, skeletonProps }) => (
        <Skeleton key={`${rowId}-${key}`} {...skeletonProps} />
      ))}
    </div>
  ));
};
